export const CLOSE_DOCUMENT_RENAMING_DIALOG = 'CLOSE_DOCUMENT_RENAMING_DIALOG'
export const OPEN_DOCUMENT_RENAMING_DIALOG = 'OPEN_DOCUMENT_RENAMING_DIALOG'
export const RENAME_DOCUMENT = 'RENAME_DOCUMENT'
